import React from "react";
import { Link } from "@quintype/components";
import { string, object } from "prop-types";
import { useSelector } from "react-redux";

import { getCookie, handleAccessLevelRedirect, linkTarget, validURL } from "../../utils/utils";

const Anchor = ({ href = "/", target, accessLevelData, ...props }) => {
  if (href === "#") {
    return React.createElement("div", { ...props });
  }

  const host = useSelector((state) => state?.qt?.currentHostUrl);
  const publisherAttributes = useSelector((state) => state?.qt?.config?.["publisher-attributes"]) || {};

  target = target || linkTarget(host, href) || "_self";

  if (!validURL(href)) {
    const slush = href?.match(/^\//gm);
    href = slush ? href : "/" + href;
  }

  if (accessLevelData) {
    const { access, url } = accessLevelData;
    const userId = getCookie("userID");

    href = handleAccessLevelRedirect(access, url, userId, publisherAttributes) || href;
  }

  return React.createElement(target === "_blank" ? "a" : Link, { target, href, ...props });
};

Anchor.defaultProps = {
  "aria-label": "",
  accessLevelData: null,
};

Anchor.propTypes = {
  href: string,
  target: string,
  "aria-label": string,
  accessLevelData: object,
};

export default Anchor;
